import { TikTokIcon } from '@change/ds-icons/TikTokIcon';

export const SocialPostThumbnailFallback: React.FC<Props> = ({ variant, qaId }) => (
	<div
		aria-hidden="true"
		className="text-icon-inverse-strong-fixed relative flex h-full w-full items-center justify-center overflow-hidden bg-black"
		data-qa={qaId}
	>
		<div
			className={
				variant === 'hero'
					? 'bg-fill-inverse-hover-fixed absolute -top-24 -right-16 size-64 rounded-full'
					: 'bg-fill-inverse-hover-fixed absolute -top-8 -right-8 size-24 rounded-full'
			}
		/>
		<div
			className={
				variant === 'hero'
					? 'bg-fill-inverse-hover-fixed absolute -bottom-16 -left-12 size-40 rounded-full'
					: 'bg-fill-inverse-hover-fixed absolute -bottom-6 -left-6 size-16 rounded-full'
			}
		/>
		<div
			className={
				variant === 'hero'
					? 'bg-fill-inverse-hover-fixed relative flex size-24 items-center justify-center rounded-full shadow-sm'
					: 'bg-fill-inverse-hover-fixed relative flex size-14 items-center justify-center rounded-full shadow-sm'
			}
		>
			<TikTokIcon size={variant === 'hero' ? 'x-large' : 'large'} />
		</div>
	</div>
);

type Props = {
	variant: 'compact' | 'hero';
	qaId: string;
};
